import axios from 'axios';

const BASE_URL = "http://localhost:4545";

async function getPrinters() {
    const response = await axios.get(`${BASE_URL}/printers`);
    return response.data;
}

async function printBarcode(printerId, prnData) {
    const data = {
        printerId,
        content: prnData,
    };
    return axios.post(`${BASE_URL}/print`, data, { headers: { "Content-Type": "text/plain" } });
}

const BarcodePrintService = {
    getPrinters,
    printBarcode,
};

export default BarcodePrintService;
